import { Box } from "@mui/material";
import CustomTableRow from "../table/CustomTableRow";
import { DeleteOutlined, EditOutlined } from "@mui/icons-material";
import React, { useState } from "react";
import useAuthFetch from "../../hooks/useAuthFetch";
import ConfirmBox from "../ConfirmBox";
import { format } from "date-fns";
import toast from "react-hot-toast";

export default function UserTableRow({
  row,
  refetch,
  setOpen,
  setSelectedRow,
}) {
  const [openErr, setOpenErr] = useState(false)
  const [openConfirm, setOpenConfirm] = useState(false)
  const [errMsg, setErrMsg] = useState(null)
  const customFetch = useAuthFetch();

  const handleUpdate = () => {
    setSelectedRow(row);
    setTimeout(() => (
      setOpen(true)
    ), 1000)

  };

  const handleDelete = async () => {
    try {
      const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/user/delete`);
      const method = "POST"
      const bodyContent = {
        id: row.userId
      }
      const { response, status, message } = await customFetch(
        url,
        method,
        bodyContent
      );
      if (status !== 200) {
        setOpenConfirm(false)
        setOpenErr(true)
        setErrMsg(message)
        console.log("Error in deleting user", response);
      }
      toast.success("User Deleted Succesfully!", {
        position: "bottom-right",
      })
      setOpenConfirm(false)
      refetch();

    } catch (error) {
      console.error("Error delete user:", error);
    }
  };
  const ShowButtons = () => {
    return (
      <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <button onClick={handleUpdate}>
          <EditOutlined className="w-5 h-5 text-black-150" />
        </button>
        <button onClick={() => setOpenConfirm(true)}>
          <DeleteOutlined className="w-5- h-5 text-black-150" />
        </button>
      </Box>
    );
  };


  return (
    <>
      <CustomTableRow
        columns={[
          {
            text: row.userName
          },
          {
            text: row.ntID
          },
          {
            text: `${row.role === "SUPPORT" ? "IDM SUPPORT" : row.role}`
          },
          {
            text: `${row.meTicketNo}`
          },
          { text: row.lastSuccessfulLogin ? format(new Date(row.lastSuccessfulLogin), "dd MMM yyyy, hh:mm a") : "N/A" },
          { text: row.lastFailedLogin ? format(new Date(row.lastFailedLogin), "dd MMM yyyy, hh:mm a") : "N/A" },

          {
            actions: [ShowButtons],
          },
        ]}
      ></CustomTableRow>
      <ConfirmBox
        open={openErr}
        setOpen={setOpenErr}
        buttonText={"Close"}
        text={errMsg ? errMsg : "Something went wrong while deleting the user!"}
      />
      <ConfirmBox
        open={openConfirm}
        setOpen={setOpenConfirm}
        buttonText={"Confirm"}
        buttonHandler={() => {
          handleDelete()
        }}
        extraButtonText={"Cancel"}
        extraButtonHandler={() => {
          setOpenConfirm(false)
        }}
        text={"Are you sure you want to delete the user?"}
      />
    </>
  );
}
